import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PTE_AUTHORIZATION_KEY = process.env.REACT_APP_PTE_AUTHORIZATION_KEY;
const PTE_DEVICE_TOKEN_KEY = process.env.REACT_APP_PTE_DEVICE_TOKEN_KEY;

export const submitApplicationData = async (ddaData) => {
    try {
        const headers = {
            "actioncode": "Q2AUTOPOST",
            "authorization": PTE_AUTHORIZATION_KEY,
            "content-type": "application/json",
            "devicetoken": PTE_DEVICE_TOKEN_KEY
        };



        const response = await axios({
            method: 'post',
            url: API_BASE_URL,
            headers: headers,
            data: ddaData
        });



        return response.data;
    } catch (error) {
        
        if (error.response) {

        }
        
        throw error;
    }
}; 